import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthenticationService } from "@assoanalytics/app/core/services/api/auth/authentication.service";
import { AuthService } from "@assoanalytics/app/core/services/auth.service";
import { StorageService } from "@assoanalytics/app/core/services/storage.service";
import { TokenService } from "@assoanalytics/app/core/services/token.service";

@Component({
  selector: "app-external-link-manager",
  template: "",
  standalone: true,
})
export class ExternalLinkManagerComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private tokenService: TokenService,
  ) {}

  async ngOnInit() {
    const url = await this.route.snapshot.queryParamMap.get("url");
    const token = this.tokenService.getToken();

    if (!url || !token || this.authService.isTokenExpired(token)) {
      this.router.navigate(["/dashboard"]);
      return;
    }

    // Costruisci l'URL con il token come querystring
    const urlObj = new URL(url, window.location.origin);
    urlObj.searchParams.set("token", token);

    this.router.navigate(["/goodbye"]).then(() => {
      setTimeout(() => window.location.replace(urlObj.toString()), 1500);
    });
    // window.open(urlObj.toString(), "_self");
    // this.router.navigate(["/dashboard"]);
  }
}
